export const LanguageId = {
  VN: 'vi-VN',

  TH: 'th-TH',

  DE: 'de-DE',

  EN: 'en-US',

  KH: 'km-KH',

  LA: 'lo-LA',

  CN: 'zh-CN',
};

export const GuidEmpty = '00000000-0000-0000-0000-000000000000';

export const RegexValidatePhone = /\d([+(-.\s]?\d{1,}[+)-.\s]?){4,}\d/;

export const RegexValidateEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const PasswordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,130}$/;

// Enum ModelState tương ứng với BE
export const ModelState = {
  None: 0,
  Insert: 1,
  Update: 2,
  Delete: 3,
  // cập nhật thông tin employee
  EditInfoEmployee: 4,
  // cập nhật thông tin active của employee
  EditInactive: 5,
  // reset pass
  EditPassword: 6,
};
